<template>
  <div class="dropDownMainContainer">
    <div class="dropDownWrapper" @click="toggleDropdown">
      <span style="width: 30px; font-weight: bold;">{{ selectedFlag.codeText.toUpperCase() }}</span>
      <img src="/assets/images/svg/down_arrow.svg" class="transition" :style="isOpen ? 'transform: rotate(180deg)' : ''" alt="">
    </div>
    <div v-if="!hidden" ref="dropDownMenu" class="dropDownMenu transition" style="z-index: 100;">
      <div class="menuItem" :key="lang.code" v-for="lang in languages" @click="selectLanguage(lang)">
        <!-- <img class="flagImage" :src="lang.flag" :alt="lang.code"> -->
        <span style="width: 30px;">{{ lang.codeText.toUpperCase() }}</span>
        <span
          class="languageText"
          v-html="selectedLanguage === lang.code ? `<b>${lang.text}</b>` : lang.text"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "language-dropdown",
  props: {
    languages: {
      type: Array,
      required: true,
      default: () => [{ text: "English", code: "en", flag: "/assets/images/flags/england.svg" }]
    }
  },
  data: () => {
    return {
      selectedLanguage: "en",
      isOpen: false,
      disabled: true, // to prevent misclicks while in the animation
      hidden: true
    }
  },
  computed: {
    selectedFlag () {
      return this.languages.find(el => el.code === this.selectedLanguage)
    }
  },
  beforeMount () {
    // let lang = localStorage.getItem("lang");
    // if (lang) this.selectedLanguage = lang
    setTimeout(() => {
      this.selectedLanguage = this.locale
    }, 2000)
  },
  mounted () {
  },
  methods: {
    toggleDropdown () {
      let dropDownMenu = this.$refs['dropDownMenu'];
      if (this.isOpen) { // if dd is open
        dropDownMenu.style.transform = "translate(0px, -70px)"
        dropDownMenu.style.opacity = "0"
        this.disabled = true;
        setTimeout(() => {
          this.hidden = true;
        }, 333);
      } else { // if dd is closed
        this.hidden = false;
        this.disabled = false;
        setTimeout(() => {
          dropDownMenu = this.$refs['dropDownMenu'];
          dropDownMenu.style.transform = "translate(0px, 0px)"
          dropDownMenu.style.opacity = "1"
        }, 0);
      }
      this.isOpen = !this.isOpen
    },
    selectLanguage (lang) {
      if (!this.disabled) {
        this.selectedLanguage = lang.code
        // localStorage.setItem('lang', this.selectedLanguage);
        this.locale = this.selectedLanguage
        this.toggleDropdown()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dropDownMainContainer {
  position: relative;
  margin-left: 10px;
  margin-right: 10px;
}
.dropDownWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 65px;
  height: 36px;
  background: #FFFFFF;
  border-radius: 4px;
  transition: all .3s;

  &:hover {
    cursor: pointer;
    box-shadow: 0px 8px 16px -4px #EBEBEB;
  }
}

.dropDownMenu {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  background: #fff;
  opacity: 0;
  transform: translate(0, -70px);
  border-radius: 4px;
  margin-top: 10px;
  width: 183px;
  box-shadow: 0px 8px 16px -4px rgb(204, 204, 204);

  .menuItem {
    background: #fff;
    width: 90%;
    padding: 4px 8px 4px 8px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #F7F7F7;

    &:first-child {
      margin-top: 8px;
    }

    &:last-child {
      border: none;
      margin-bottom: 8px;
    }
    .flagImage {
      margin-right: 10px;
    }

    .languageText {
      font-size: 14px;
    }

    &:hover {
        background: #F7F7F7;
    }
  }
}

.transition {
  transition: all 0.3s;
}
</style>
